import { db, auth, _firebase, analytics } from '@/main.js'
import constants from '@/lib/constants.js'
import scripts from '@/assets/scripts.json'
import api from '@/lib/api.js'
import parse_name from 'parse-full-name'

export default {
  data() {
    return {
      geo: undefined,
      loading: false
    }
  },
  methods: {
    async create_account(user, extra) {
      if (!extra) extra = {}
      let geo = await this.geo
      let country = 'US'
      if (geo) {
        country = geo.country
      }

      let display_name = extra.name || user.displayName
      let domain = extra.domain || null

      let respone = await api.find_invite(user.email, user.uid, display_name)

      let team_doc = db.collection('team').doc(respone.data.team_id)
      let team_member_doc = db.collection('team').doc(respone.data.team_id).collection('member').doc(respone.data.team_member_id)

      let script = []
      for (let line of scripts) {
        script.push({text: line, audio_url: null})
      }

      let name = parse_name.parseFullName(display_name)

      let avatar_doc = db.collection('voice').doc()
      await avatar_doc.set({
        created: new Date(),
        updated: new Date(),
        team: team_doc,
        uid: user.uid,
        user: db.collection('user').doc(user.uid),
        name: display_name,
        status: 'training',
        description: '',
        language: 'en',
        accent: 'en-US',
        gender: null,
        provider_id: null,
        provider: 'descript',
        training_audio_url: null,
        descript_voice_id: null,
        descript_username: null,
        descript_password: null,
        script: script,
        public: false
      })

      await db.collection('user').doc(user.uid).set({
        created: new Date(),
        updated: new Date(),
        email: user.email,
        name: display_name,
        domain: domain,
        first_name: name.first,
        last_name: name.last,
        role: constants.roles.user,
        default_timezone_offset: 0,
        stripe_person: null,
        verified_identity: false,
        voices_count: 1,
        sequences_count: 0,
        projects_count: 0,
        api_key: `${db.collection('random').doc().id}${db.collection('random').doc().id}${db.collection('random').doc().id}`,
        avatar: avatar_doc,
        team: team_doc,
        team_role: team_member_doc,
        country: country
      })

      if (extra.name) {
        user.updateProfile({displayName: extra.name})
      }

      this.loading = false

      // TODO disable billing
      // if (respone.data.checkout_session_id) {
      //   this.$swal({title: 'Redirecting please wait', text: "You are being redirected to the payment page, please wait", timer: 6000})
      //   this.$swal.showLoading()
      //
      //   db.collection("customers").doc(user.uid).collection("checkout_sessions").doc(respone.data.checkout_session_id).onSnapshot((snap) => {
      //     const { error, sessionId } = snap.data()
      //     if (error) { // TODO
      //       alert(`An error occured: ${error.message}`);
      //     }
      //     if (sessionId) {
      //       /*eslint-disable */
      //       const stripe = Stripe(config.stripe.key)
      //       /*eslint-enable */
      //       stripe.redirectToCheckout({ sessionId })
      //       this.$swal.hideLoading()
      //     }
      //   })
      // }
    },
    async get_geo() {
      try { // fallback
        let response = await fetch(`https://customer.api.drift.com/geo/v2`, {method: 'GET'})

        if (!response.ok) {
          throw new Error('error fetching ipdata')
        }

        let geo = await response.json()

        // geo.city = geo2.city
        // geo.postal = geo2.postalCode
        // geo.country_name = geo2.countryName
        // geo.region = geo2.subdivision
        // geo.country_code = geo2.country
        // geo.is_eu = geo2.gdprApplicable
        // geo.metroCode = geo2.metroCode
        // geo.latitude = geo2.latitude
        // geo.longitude = geo2.longitude
        // geo.ip = geo2.ip

        return geo
      } catch (err) {
        console.warn(err)
      }

      return null
    },
    async signin_google() {
      let provider = new _firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({'access_type': 'offline'})

      let result = await auth.signInWithPopup(provider)

      let user = result.user
      if (result && result.additionalUserInfo && result.additionalUserInfo.isNewUser) {
        await this.create_account(user)
      }
    },
  },
  created () {
    this.geo = this.get_geo()
  }
}
